import constants from './CommonConstants';

// list views
export const ORGANIZATION_LIST = 'organization-list';
export const ACCOUNT_LIST = 'account-list';
export const CONTACT_LIST = 'contact-list';
export const PIPELINE_LIST = 'pipeline-list';

// board views
export const ORGANIZATION_BOARD = 'organization-board';
export const ACCOUNT_BOARD = 'account-board';
export const CONTACT_BOARD = 'contact-board';
export const PIPELINE_BOARD = 'pipeline-board';

// 360 profiles
export const ORGANIZATION_360 = 'organization-360';
export const ACCOUNT_360 = 'account-360';
export const CONTACT_360 = 'contact-360';

export const LEVEL_LIST_MAPPING = {
  [constants.ORGANIZATION_LEVEL]: ORGANIZATION_LIST,
  [constants.ACCOUNT_LEVEL]: ACCOUNT_LIST,
  [constants.CONTACT_LEVEL]: CONTACT_LIST,
  [constants.PIPELINE_LEVEL]: PIPELINE_LIST,
};

export const LEVEL_BOARD_MAPPING = {
  [constants.ORGANIZATION_LEVEL]: ORGANIZATION_BOARD,
  [constants.ACCOUNT_LEVEL]: ACCOUNT_BOARD,
  [constants.CONTACT_LEVEL]: CONTACT_BOARD,
  [constants.PIPELINE_LEVEL]: PIPELINE_BOARD,
};

export const LEVEL_360_MAPPING = {
  [constants.ORGANIZATION_LEVEL]: ORGANIZATION_360,
  [constants.ACCOUNT_LEVEL]: ACCOUNT_360,
  [constants.CONTACT_LEVEL]: CONTACT_360,
};
